import {IInputChannel} from './inputChannel.interface';
import {Constants} from '../constants';

export class NucleusInputChannelModel implements IInputChannel {
  name: string;
  configuration: any;
  constructor() {
    this.name = Constants.CHANNELS.NUCLEUS
    this.configuration = {};
    this.configuration.token = 'test';
    this.configuration.thing = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/rules/model/nucleus.input.channel.model.ts